"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
function default_1({ isAdultPlus, isHotCommission, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const CoverText = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isAdultPlus && !isHotCommission && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [`🩸${t('유혈 주의')}🩸`, (0, jsx_runtime_1.jsx)("br", {})] })), t('콘텐츠 안내'), (0, jsx_runtime_1.jsx)("br", {}), isHotCommission ? (isAdultPlus ? (`🩸${t('유혈 주의')}🩸`) : (t('성인만'))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('작가님이 성인만 볼 수 있는'), (0, jsx_runtime_1.jsx)("br", {}), t('콘텐츠로 표시했어요')] }))] }));
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            fontSize: '13px',
            lineHeight: '20px',
            color: 'white',
            border: '0.5px solid rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(20px)',
            pointerEvents: 'none',
        } }, { children: CoverText })));
}
exports.default = default_1;
